import { mapState } from 'vuex';

import AppHeader from '@/components/partials/AppHeader/AppHeader.vue';

export default {
  name: 'index',
  components: {
    AppHeader,
  },
}